// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090624/js/" + chunkId + "." + {"44":"7a3ee423","225":"4fc4d2a9","481":"c2430f72","486":"5f6b365a","770":"cfcefaab"}[chunkId] + ".0.2341111143882375.chunk.js";
};